var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickpartsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.28 100.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#db60cc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 100.28,
    height: 100.28,
    rx: 15.82,
    ry: 15.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.63,50.78c0-18.45,13.49-31.67,32.04-31.67s31.95,13.22,31.95,31.67c0,8.63-3.03,16.16-7.99,21.66l4.5,5.23-9.09,7.44-4.96-5.69c-4.22,1.93-9.18,3.03-14.41,3.03-18.54,0-32.04-13.22-32.04-31.67Zm38.37,19.09l-6.7-7.89,9.09-7.44,6.7,7.89c2.02-3.21,3.12-7.25,3.12-11.66,0-11.47-7.25-20.1-18.54-20.1s-18.63,8.63-18.63,20.1,7.25,20.1,18.63,20.1c2.29,0,4.41-.37,6.33-1.01Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickpartsLogo);
export default __webpack_public_path__ + "static/media/quickparts_logo.4956de80889025ee8fa9e047ad26be02.svg";
export { ForwardRef as ReactComponent };